//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../constant/EndPoint";
import useTenantControlGetHook from "../customHooks/useTenantControlGetHook";
import Heading from "./Heading";
import Services from "./Services";

const Welcome = ({ profile, websiteData }) => {
  const { data, isLoading } = useTenantControlGetHook({
    url: APIS.WELCOME_PAGE,
    queryKey: ["welcome-page"],
    params: {},
  });

  if (isLoading) return <></>;

  if (data?.image) {
    return (
      <div
        className={tw`flex`}
        style={{ height: "100vh"}}
      >
        <img
          src={data.image}
          alt="welcome"
          className={tw`w-full h-full object-fit`}
        />
      </div>
    );
  }

  return (
    <div
      className={tw`flex flex-col`}
      style={{ height: "calc(100vh - 320px)" }}
    >
      <Heading profile={profile} />
      <div className={tw`flex-1 w-full h-full`}>
        <Services />
      </div>
    </div>
  );
};

export default Welcome;
